export default "__VITE_ASSET__8r6VS$Ry__"